// client/src/scheduling/utils/localDev.js
// True when the page is served by a local dev runtime (SWA CLI / CRA on localhost). A
// deployed site never is. Mirrors api/shared/errorLog.js isLocalDevRequest on the server.
export function isLocalHost(loc = window.location) {
  return /^(localhost|127\.0\.0\.1)$/.test(String(loc && loc.hostname));
}
